import React from "react";
import { twMerge } from "tailwind-merge";
import { Tooltip } from "@chakra-ui/react";

const classes = "p-4";

const CellPrimary = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <td className={twMerge("min-w-[300px] text-primaryPurple-100", classes, className)}>
    {children}
  </td>
);

const CellCentered = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <td className={twMerge("text-center", classes, className)}>{children}</td>;

const CellNoWrap = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <td className={twMerge("whitespace-nowrap", classes, className)}>{children}</td>
);

const CellLineClamp2 = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <td className={twMerge(classes, className)} style={{ minWidth: "400px" }}>
    <Tooltip label={children} className="w-96 rounded-md bg-deep-purple-50 p-2">
      <span className="line-clamp-2 ">{children}</span>
    </Tooltip>
  </td>
);

type CellProps = {
  children: React.ReactNode;
  type?: "center" | "nowrap" | "line-clamp-2" | "primary";
  className?: string;
};

export const Cell = ({ children, type, className }: CellProps) => {
  switch (type) {
    case "primary":
      return <CellPrimary className={className}>{children}</CellPrimary>;
    case "center":
      return <CellCentered className={className}>{children}</CellCentered>;
    case "nowrap":
      return <CellNoWrap className={className}>{children}</CellNoWrap>;
    case "line-clamp-2":
      return <CellLineClamp2 className={className}>{children}</CellLineClamp2>;
    default:
      return <td className={className}>{children}</td>;
  }
};

export const TableHeader = ({ headers }: { headers: string[] }) => (
  <thead>
    <tr>
      {headers.map((head) => (
        <th
          key={head}
          className="border-b border-blue-gray-100 bg-deep-purple-50 p-4 font-semibold"
          style={{ textWrap: "nowrap" }}
        >
          <span>{head}</span>
        </th>
      ))}
    </tr>
  </thead>
);

export const TableRow = ({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => (
  <tr
    onClick={onClick}
    className={twMerge(onClick ? " hover:bg-gray-50" : "hover:bg-gray-50", className)}
  >
    {children}
  </tr>
);
